import {
    CLEAR_BUSINESS,
    SET_CURRENT_BUSINESS,
    SET_BUSINESS_LIST,
    SET_BUSINESS_PRODUCTION_MODE,
    CLEAR_CURRENT_BUSINESS
} from "../actions/types";

const initialState = {current: {}, list: [], isBusinessProduction: null};

export default function business(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case SET_CURRENT_BUSINESS:
            return {
                ...state,
                current: {...payload}
            };

        case CLEAR_CURRENT_BUSINESS:
            return {
                ...state,
                current: {}
            };

        case SET_BUSINESS_LIST:
            return {
                ...state,
                list: [...payload]
            };

        case SET_BUSINESS_PRODUCTION_MODE:
            return {
                ...state,
                isBusinessProduction: payload
            };

        case CLEAR_BUSINESS:
            return initialState

        default:
            return state;
    }
}
